import { appContent } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900 rounded-lg overflow-hidden">
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-10 p-8 md:p-12">
              <div className="flex-1 text-center md:text-left">
                <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
                  {appContent.title}
                </h2>
                <p className="mt-2 text-lg text-primary-200">{appContent.subtitle}</p>
                <p className="mt-4 text-sm md:text-base text-primary-100/80 leading-relaxed">
                  {appContent.desc}
                </p>

                <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 mt-5">
                  {appContent.features.map((f) => (
                    <span key={f} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/15 text-primary-100 text-xs font-medium">
                      <i className="ri-check-line text-sm"></i>
                      {f}
                    </span>
                  ))}
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3 mt-7">
                  <a
                    href="#"
                    className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 hover:bg-accent-100 text-primary-700 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-apple-line text-lg"></i>
                    iOS 下载
                  </a>
                  <a
                    href="#"
                    className="inline-flex items-center gap-2 px-7 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/30 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-android-line text-lg"></i>
                    Android 下载
                  </a>
                </div>
              </div>

              <div className="flex-shrink-0 w-48 md:w-56">
                <div className="w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-50/10 flex items-center justify-center">
                  <img
                    src={appContent.appImage}
                    alt="每日爆料 APP 界面展示"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}